<template>
    <div id="booking-heading-container" class="shadow-reg mb-6">
        <div class="row">
            <div class="col-12">
                <h6 class="heading-small text-muted text-uppercase montserrat mb-2">Selected shop</h6>
            </div>
            <div id="profile-heading" class="col">
                <h2 class="display-4 montserrat-bold mb-2" v-text="shop.name"></h2>
                <div class="mt--2 heading-small" v-text="(shop.address || {}).display_name"></div>
                <div class="mt-2">
                    <router-link :to="shopProfileLink" v-slot="{ href, navigate }">
                        <a :href="href" @click="navigate" class="btn bg-secondary text-dark shadow-reg mt-2">
                            <i class="fa fa-eye mr-2"></i> View Shop
                        </a>
                    </router-link>
                </div>
            </div>
            <div class="col-auto image-container">
                <avatar-badge :src="shop.display_image" class="mt-5" update-event="display-image-updated" :raised="false" :size="150"></avatar-badge>
            </div>
        </div>
    </div>
</template>
<script>
import { pageRoute } from "@utils/network";
export default {
    name: "BookingHeading",

    computed: {
        shopProfileLink() {
            return pageRoute('/shops/:id/about', { id: this.shop.id }, false);
        },
    },

    props: {
        shop: Object
    }
}
</script>